import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import styled from 'styled-components';

import { breakpoints } from 'theme/variables';

import { Antd3Form } from '../deprecated/antd3';

const SubmitButtonContainer = styled(Antd3Form.Item)`
    && {
        margin-bottom: 0;
        margin-top: 8px;

        button {
            width: 100%;
            height: 46px;
            border-radius: 8px;
            font-size: 0.92rem;
            font-weight: 600;
            font-family: 'Inter', sans-serif;
        }

        ${breakpoints.small} {
            margin: 8px 0 0;
        }
    }
`;

interface SubmitButtonProps {
    disabled?: boolean;
    isFetching?: boolean;
    htmlType?: string;
    value: string;
}

type Props = SubmitButtonProps & ButtonProps;

export const SubmitButton = ({
    isFetching,
    value,
    disabled = false,
    htmlType,
    ...props
}: Props) => (
    <SubmitButtonContainer>
        <Button
            disabled={disabled}
            type="primary"
            htmlType={htmlType || 'submit'}
            loading={isFetching}
            {...props}
        >
            {value}
        </Button>
    </SubmitButtonContainer>
);
